// +-------------------------------------------------------------
// | Created by WebStorm.
// +-------------------------------------------------------------
// | User: msmile
// +-------------------------------------------------------------
// | Date: 2025/5/8
// +-------------------------------------------------------------
// |Time: 17:38
// +-------------------------------------------------------------
import Login from "@/views/Login/Index";
import BasicLayout from "@/layouts/BasicLayout.vue";
import Auth from "@/router/module/auth";
import Management from "@/router/module/management";
import Setting from "@/router/module/setting";
import Order from "@/router/module/order";
import Activities from "@/router/module/activities";
import User from "@/router/module/user";
export default [
    {
        path: '/',
        redirect: '/workSpace'
    },
    {
        path: '/login',
        name: "HomeLogin",
        component: Login,
        meta: {title: '登录页面'},
    },
    {
        path: '/workSpace',
        name: 'BasicLayout',
        redirect: '/dashboard',
        component: BasicLayout,
        meta: { title: '工作台' },
        children: [
            {
                path: '/dashboard',
                name: 'AppDashboard',
                component: () => import('@/views/WorkSpace/Dashboard'),
                meta: {title: '首页'},
            },
            ...Auth,
            ...Management,
            ...Order,
            ...Setting,
            ...Activities,
            ...User
        ]
    }
]